import React from 'react';
import { Button } from '../ui/Button';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, Sparkles, Share2, RefreshCw } from 'lucide-react';
export function VisualizationStep() {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} className="max-w-5xl mx-auto" data-id="element-263">
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-264">
        <div className="grid lg:grid-cols-2" data-id="element-265">
          {/* Visualization Area */}
          <div className="bg-primary/30 p-8 lg:p-12 flex flex-col items-center justify-center relative min-h-[400px] lg:min-h-[600px]" data-id="element-266">
            <div className="absolute top-6 left-6 bg-white px-3 py-1 rounded-full text-xs font-bold text-accent shadow-sm flex items-center gap-1" data-id="element-267">
              <Sparkles className="w-3 h-3" data-id="element-268" />
              AI Generated
            </div>

            {/* Silhouette + Dress Overlay */}
            <div className="relative w-64 h-96" data-id="element-269">
              {/* Body */}
              <div className="absolute inset-0 bg-gray-200 rounded-full opacity-50 mx-auto w-32" data-id="element-270"></div>
              {/* Dress */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.5,
              duration: 0.8
            }} className="absolute inset-0 z-10 drop-shadow-2xl" data-id="element-271">
                <svg viewBox="0 0 100 150" className="w-full h-full fill-accent" data-id="element-272">
                  <path d="M30,20 Q50,35 70,20 L80,30 L75,90 L90,140 L10,140 L25,90 L20,30 Z" data-id="element-273" />
                </svg>
              </motion.div>
            </div>

            <p className="mt-8 text-sm text-text-muted font-medium" data-id="element-274">
              Visualized on 5'2" frame
            </p>
          </div>

          {/* Analysis Panel */}
          <div className="p-8 lg:p-12 flex flex-col justify-center" data-id="element-275">
            <div className="mb-8" data-id="element-276">
              <h2 className="text-3xl font-serif font-bold text-text-primary mb-2" data-id="element-277">
                Your Perfect Fit
              </h2>
              <p className="text-lg text-text-muted" data-id="element-278">
                Ann Taylor Petite Shift Dress
              </p>
            </div>

            <div className="bg-green-50 border border-green-100 rounded-xl p-6 mb-8" data-id="element-279">
              <div className="flex items-center gap-2 mb-4" data-id="element-280">
                <CheckCircle className="w-5 h-5 text-green-600" data-id="element-281" />
                <span className="font-bold text-green-800" data-id="element-282">
                  Excellent Match
                </span>
              </div>
              <p className="text-green-700 mb-4" data-id="element-283">
                This item is perfectly scaled for your vertical proportions.
              </p>
              <div className="space-y-2" data-id="element-284">
                <div className="flex justify-between text-sm" data-id="element-285">
                  <span className="text-green-800" data-id="element-286">Rise / Waist Placement</span>
                  <span className="font-medium text-green-900" data-id="element-287">Perfect</span>
                </div>
                <div className="w-full bg-green-200 h-1.5 rounded-full" data-id="element-288">
                  <div className="bg-green-600 h-1.5 rounded-full w-full" data-id="element-289"></div>
                </div>

                <div className="flex justify-between text-sm mt-3" data-id="element-290">
                  <span className="text-green-800" data-id="element-291">Hem Length</span>
                  <span className="font-medium text-green-900" data-id="element-292">Ideal</span>
                </div>
                <div className="w-full bg-green-200 h-1.5 rounded-full" data-id="element-293">
                  <div className="bg-green-600 h-1.5 rounded-full w-[95%]" data-id="element-294"></div>
                </div>
              </div>
            </div>

            <div className="mb-8" data-id="element-295">
              <h3 className="font-bold text-text-primary mb-2" data-id="element-296">
                Recommendation
              </h3>
              <p className="text-text-primary text-lg" data-id="element-297">
                We recommend{' '}
                <span className="font-bold bg-accent/10 px-2 py-0.5 rounded text-accent" data-id="element-298">
                  Size 4 Petite
                </span>
              </p>
            </div>

            <div className="space-y-4" data-id="element-299">
              <Button className="w-full flex items-center justify-center gap-2" data-id="element-300">
                <Share2 className="w-4 h-4" data-id="element-301" /> Save This Fit
              </Button>
              <Button variant="secondary" className="w-full flex items-center justify-center gap-2" data-id="element-302">
                <RefreshCw className="w-4 h-4" data-id="element-303" /> Try Another Item
              </Button>
              <div className="text-center pt-2" data-id="element-304">
                <Link to="/" className="text-sm text-text-muted hover:text-accent transition-colors" data-id="element-305">
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>;
}